import { HttpClient } from '../http-client';
import type { BaseResponse } from '../types/common';
import type {
  TenantImportRequest,
  TenantRegisterRequest,
  TenantRegisterResponse,
  TenantResponse,
  TenantSearchRequest,
  TenantSearchResponse,
  TenantUpdateRequest
} from '../types/tenant.types';

function normalizePageable(params: TenantSearchRequest): TenantSearchRequest {
  return {
    ...params,
    pageable: {
      pageNumber: params.pageable?.pageNumber ?? 0,
      pageSize: params.pageable?.pageSize ?? 20,
      sort: params.pageable?.sort ?? { orders: [] }
    }
  };
}

class TenantService {
  private http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  async search(params: TenantSearchRequest = {}): Promise<TenantSearchResponse> {
    return this.http.requestAndValidate<TenantSearchResponse>('/tenants/search', {
      method: 'POST',
      body: normalizePageable(params)
    });
  }

  async getById(tenantId: string): Promise<TenantResponse> {
    return this.http.requestAndValidate<TenantResponse>('/tenants/by-id', {
      method: 'POST',
      body: { tenantId }
    });
  }

  async getByCode(code: string): Promise<TenantResponse> {
    return this.http.requestAndValidate<TenantResponse>('/tenants/by-key', {
      method: 'POST',
      body: { code }
    });
  }

  async register(data: TenantRegisterRequest): Promise<TenantRegisterResponse> {
    return this.http.requestAndValidate<TenantRegisterResponse>('/tenants/register', {
      method: 'POST',
      body: data
    });
  }

  async importTenant(data: TenantImportRequest): Promise<TenantRegisterResponse> {
    return this.http.requestAndValidate<TenantRegisterResponse>('/tenants/import', {
      method: 'POST',
      body: data
    });
  }

  async update(data: TenantUpdateRequest): Promise<BaseResponse> {
    return this.http.requestAndValidate<BaseResponse>('/tenants', {
      method: 'PATCH',
      body: data
    });
  }

  async delete(tenantId: string): Promise<BaseResponse> {
    return this.http.requestAndValidate<BaseResponse>('/tenants', {
      method: 'DELETE',
      body: { tenantId }
    });
  }
}

export { TenantService };
